import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { ApiIpPoolsResponse } from './types';

type Props = { artistId: string };

export const getArtistIpPools = async ({ artistId }: Props) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/ip-pools`;

  const response = await api.executeGetRequest<ObjectResponse<ApiIpPoolsResponse>>(url);

  return response.data;
};
